module.exports = __webpack_public_path__ + "img/download_code.caae3e4b.png";